export default {
    limitPerPage: 10,
    webTraderURL: 'https://trade.mql5.com/trade',
    skrill: {
        depositLink: 'deposit',
        pay_to_email: 'backoffice@aaafx.com',
        status_url: process.env.VUE_APP_SKRILL_URL,
        merchant_id: '205526338',
        merchant_fields: 'tradingAccount,email,method_id',
        return_url_target: '3',
        cancel_url_target: '3',
    },
    fileSize: {
        totalSize: 20,
        individualSize: 4,
        conversion: 1048576,
        type: "MB"
    },
    skrill_pay_to_email: { 'EUR': "moneybookers@aaafx.com", 'USD': "moneybookers_usd@aaafx.com", 'JPY': "moneybookers_jpy@aaafx.com", 'GBP': "moneybookers_gbp@aaafx.com", 'AUD': "moneybookers_aud@aaafx.com", 'CHF': "moneybookers_chf@aaafx.com" },
    withdrawalStatus: { '0': "Pending", '1': "Processed", '2': "Rejected", '3': "Canceled by User" },
    depositStatus: { '-1': "Transaction Initiated", '0': "Pending", '1': "Success", '2': "Declined", '3': "Declined", '4': "Unverified Account" },
    bonusType: { '1': "Add Bonus", '2': "Referral Bonus", '3': "Remove Bonus" },
    depositType: { '1': "Deposit", '2': "Internal Transfer", '3': "Loyalty Points" },
    withdrawalType: { '1': "Withdrawal", '2': "Internal Transfer", '3': "Subscription" },
    registrationType: [
        { label: "Individual", value: "0" },
        { label: "Corporate", value: "1" }
    ],
    leverages: [
        { label: "100X", value: "100" },
        { label: "200X", value: "200" },
        { label: "300X", value: "300" },
        { label: "400X", value: "400" },
        { label: "500X", value: "500" }
    ],
    accountTypes: [
        { label: 'ECN', value: 'ECN', min_deposit : 50 },
        { label: 'ECN Plus', value: 'ECNP', min_deposit : 1000 },
        { label: 'ISLAMIC', value: 'ISL', min_deposit : 1000 },
        { label: 'ECN Zero', value: 'NECN', min_deposit :  10000 }
        /*{ label: 'ECN Zulu', value: 'ZULU' }
        { label: 'Classic', value: 'CLASSIC' },
        { label: 'Profit Sharing', value: 'PROFIT_SHARING' }*/
    ],
    mt5accountTypes: [
        { label: 'ECN', value: 'ECN' },
        { label: 'ECN Plus', value: 'ECNP' },
        { label: 'ISLAMIC', value: 'ISL' },
        { label: 'ECN Zulu', value: 'ZULU' }
        /*{ label: 'ECN Zero', value: 'NECN' }
        { label: 'Classic', value: 'CLASSIC' },
        { label: 'Profit Sharing', value: 'PROFIT_SHARING' }*/
    ],
    platforms: [
        { label: 'MetaTrader 4', value: 'MT4' },
        { label: 'MetaTrader 5', value: 'MT5' },
        // { label: 'Zulu Trading Platform', value: 'ZTP' }
    ],
    currency: {
        'USD': '$',
        'EUR': '€',
        // 'CAD': '$',
        //'GBP': '£',
        'AUD': 'AU$',
    },
    currency_ISL: {
        'USD': '$',
        'EUR': '€',
    },
    currency_mt4: {
        'USD': '$',
        'EUR': '€',
        'AUD': 'AU$',
        'CAD': '$',
        /*'GBP': '£',
        'JPY': '¥',
        'CHF': 'CHf'*/
    },
    transactionFilter: {
        deposit: {
            1: 'Deposits',
            2: 'Internal Transfer'
        },
        withdrawal: {
            1: 'Withdrawals',
            2: 'Internal Transfer'
        }
    },
    trade_type: {
        1: 'Buy',
        2: 'Sell'
    },
    trullioCountries:{
        ZA : "South Africa",
        MY : "Malaysia",
        CN : "China",
        SG : "Singapore",
        HK : "Hong Kong",
        AU : "Australia",
        CA : "Canada",
        AE : "United Arab Emirates",
        TR : "Turkey",
        EG : "Egypt",
        TH : "Thailand",
        VN : "Vietnam",
        PH : "Philippines",
        ID : "Indonesia"
    },
    // visibleMethods: { '1': "Bank", '2': "Skrill", '3': "Neteller", '4': "Trading Account", '5': "Debit/Credit card", '6': "Giropay", '7': "Przelewy", '8': "Rapid Transfer", '9': "Nordea", '10': "Klarna", '11': "NBP", '12': "TR", '13': "CR", '15': "Loyalty Transfer", '18': "Bitcoin", '17': "Praxis", '19': "LBT-Gatech", '20': "LBT-Payguru", '21': "LBT-PayRetailer", '22': "LBT-Rapid OZOW" },
    visibleMethods: { '1': 'Bank', '2': 'Instant Deposit - Skrill', '3': 'Neteller', '4': 'Trading Account', '5': 'Credit Card', '6': 'Giropay', '7': 'Przelewy24', '8': 'Rapid Transfer', '9': 'Nordea', '10': 'Klarna', '11': 'NBP', '12': 'TR', '13': 'CR', '15': 'Loyalty Transfer', '18': 'Capital Wallet', '17': 'Praxis', '19': 'LBT-Gatech', '20': 'LBT-Payguru', '21': 'LBT-PayRetailer', '22': 'LBT-Rapid OZOW', '23': 'Virtual Pay', '24': 'PRAXIS-HELP2PAY', '25': 'Dixipay', '26': 'EuroBank', '27': 'Performance Fee Subscription', '28': 'InactivityFee', '29': 'Paytoday', '30': 'Reward', '31': 'Alopay', '32': 'Credit Transaction', '33': 'PerformanceFee', '34': 'Paymentasia', '36': 'Refund', '38': 'PayPal', '39': 'Qiwi', '40': 'Credit Card - Wirecard', '41': 'MoneyBookers', '42': 'Teleingreso', '43': 'AAAFX Promo Card', '45': 'AutoPay', '46': 'Instant Deposit - Wirecard', '47': 'EPS', '48': 'DirectPay24', '50': 'iDeal', '51': 'Bitstamp', '52': 'ASTROPAY', '53': 'FAIRPAY CASH', '54': 'FAIRPAY ONLINE', '55': 'KoraPay', '56': 'Swiffy' },
    withdrawalMethod: { '1': 'Bank', '2': 'Instant Deposit - Skrill', '3': 'Neteller', '4': 'Trading Account', '5': 'Credit Card', '6': 'Giropay', '7': 'Przelewy24', '8': 'Rapid Transfer', '9': 'Nordea', '10': 'Klarna', '11': 'NBP', '12': 'TR', '13': 'CR', '15': 'Loyalty Transfer', '18': 'Capital Wallet', '17': 'Praxis', '19': 'LBT-Gatech', '20': 'LBT-Payguru', '21': 'LBT-PayRetailer', '22': 'LBT-Rapid OZOW', '23': 'Virtual Pay', '24': 'PRAXIS-HELP2PAY', '25': 'Dixipay', '26': 'EuroBank', '27': 'Performance Fee Subscription', '28': 'InactivityFee', '29': 'Paytoday', '30': 'Reward', '31': 'Alopay', '32': 'Credit Transaction', '33': 'PerformanceFee', '34': 'Paymentasia', '36': 'Refund', '38': 'PayPal', '39': 'Qiwi', '40': 'Credit Card - Wirecard', '41': 'MoneyBookers', '42': 'Teleingreso', '43': 'AAAFX Promo Card', '45': 'AutoPay', '46': 'Instant Deposit - Wirecard', '47': 'EPS', '48': 'DirectPay24', '50': 'iDeal', '51': 'Bitstamp', '52': 'ASTROPAY', '53': 'FAIRPAY CASH', '54': 'FAIRPAY ONLINE', '55': 'KoraPay', '56': 'Swiffy' },
    depositMethods: {
        keys: ['All', 'Bank Cards', 'E-Wallet', 'Cryptos', 'Bank Wire'],
        others:{
            /*'PayRetailers':{
                'BR':10,
                'BRA':10,
                'CL':18,
                'CHL':18,
                'MX':19,
                'MEX':19,
            }
            'Virtual Pay':{
                'UG': 21,
                'UGA': 21,
                'TZ': 22,
                'TZA': 22,
                'KE': 23,
                'KEN': 23,
            },*/
        },
        methods: [
            {
                type: 'Bank Cards',
                minimumDeposit: 10,
                methodID: 5,
                id: 0,
                name: 'Master Credit Card',
                image: 'mastercard.png',
                region: 'World Wide',
                currencies: 'EUR, USD, CHF, GBP',
                processingTime: 'Instant',
                action: '',
                key:'Ecommpay MC'
            },
            {
                type: 'Bank Cards',
                minimumDeposit: 10,
                methodID: 5,
                id: 1,
                name: 'Visa Credit Card',
                image: 'visa.svg',
                region: 'World Wide',
                currencies: 'EUR, USD, CHF, GBP',
                processingTime: 'Instant',
                action: '',
                key:'Ecommpay Visa'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 17,
                id: 2,
                name: 'Virtual Pay',
                image: 'dep6.png',
                region: 'East Africa',
                currencies: 'KES, UGX, TZS, RWF, GHC, NGN'/*'TAS, KES, MTN'*/,
                processingTime: '2-3 business days',
                action: '',
                key:'Virtual Pay'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 2,
                id: 3,
                name: 'Skrill',
                image: 'dep7.png',
                region: 'World Wide',
                currencies: 'EUR, USD, JPY, CHF, GBP, AUD',
                processingTime: '2-3 business days',
                action: '',
                key:'Skrill'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 3,
                id: 4,
                name: 'Neteller',
                image: 'dep8.png',
                region: 'World Wide',
                currencies: 'MY, TH, ID, PH, VN',
                processingTime: 'Instant',
                action: '',
                key:'Neteller'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 5,
                name: 'Capital Wallet',
                image: 'btc.png',
                region: 'World Wide',
                currencies: 'BTC',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 6,
                name: 'Capital Wallet',
                image: 'eth.png',
                region: 'World Wide',
                currencies: 'ETH',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 7,
                name: 'Capital Wallet',
                image: 'usdt.png',
                region: 'World Wide',
                currencies: 'USDT',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 8,
                name: 'Capital Wallet',
                image: 'usdc.png',
                region: 'World Wide',
                currencies: 'USDC',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 9,
                name: 'Help 2 Pay',
                image: 'dep4.png',
                region: 'South East Asia',
                currencies: 'MY, TH, ID, PH, VN',
                processingTime: 'Instant',
                action: '',
                key:'Help2Pay'
            },
            
            /*{
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id : 9,
                name: 'Bitcoin',
                image: 'bitcoin-ico.png',
                region: 'World Wide',
                currencies: 'BTC',
                processingTime: '30 mins',
                action: '',
                key:''
            },*/
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 10,
                name: 'Pay Retailers',
                image: 'dep5.png',
                region: 'Brazil, Mexico, Chile',
                currencies: 'BRL, MXN, CLP',
                processingTime: 'Instant',
                action: '',
                key:''
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 11,
                name: 'ASTROPAY',
                image: 'astropay.svg',
                region: 'World Wide',
                currencies: 'EUR, USD, GBP',
                processingTime: 'Instant',
                action: '',
                key:'AstroPay'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 12,
                name: 'FAIRPAY CASH',
                image: 'fairpay_cash.svg',
                region: 'LATAM',
                currencies: 'USD, BRL, CLP, CRC, MXN, PEN',
                processingTime: 'Instant',
                action: '',
                key:''
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 13,
                name: 'FAIRPAY ONLINE',
                image: 'fairpay_online.svg',
                region: 'LATAM',
                currencies: 'USD, BRL, CLP, CRC, MXN, PEN',
                processingTime: 'Instant',
                action: '',
                key:''
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 14,
                name: 'FNB',
                image: 'FNB.png',
                region: 'South Africa',
                currencies: 'ZAR',
                processingTime: '2-3 business days',
                action: '',
                key:''
            },
            /*{
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 15,
                name: 'Dixipay',
                image: 'dep3.png',
                region: 'Europe',
                currencies: 'EUR (Sepa Only)',
                processingTime: '2-3 business days',
                action: '',
                key:''
            },*/
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 5,
                id: 16,
                name: 'Google Pay',
                image: 'google-pay.png',
                region: 'World Wide',
                currencies: 'MY, TH, ID, PH, VN',
                processingTime: 'Instant',
                action: '',
                key:'Google Pay'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 17,
                name: 'Kora Pay',
                image: 'korapay.svg',
                region: 'Africa',
                currencies: 'KSH, NGN',
                processingTime: 'Instant',
                action: '',
                key:'KoraPay'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 5,
                id: 20,
                name: 'Apple Pay',
                image: 'apple-pay.png',
                region: 'World Wide',
                currencies: 'MY, TH, ID, PH, VN',
                processingTime: 'Instant',
                action: '',
                key:'Apple Pay'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 21,
                name: 'Swiffy',
                image: 'swiffy.svg',
                region: 'South Africa',
                currencies: 'ZAR',
                processingTime: 'Instant',
                action: '',
                key:'Swiffy'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 23,
                name: 'Capital Wallet',
                image: 'usdc.png',
                region: 'World Wide',
                currencies: 'TRXUSDT',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 24,
                name: 'Capital Wallet',
                image: 'usdc.png',
                region: 'World Wide',
                currencies: 'TRXUSDC',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
        ],
        testmethods: [
            {
                type: 'Bank Cards',
                minimumDeposit: 10,
                methodID: 5,
                id: 0,
                name: 'Master Credit Card',
                image: 'mastercard.png',
                region: 'World Wide',
                currencies: 'EUR, USD, CHF, GBP',
                processingTime: 'Instant',
                action: '',
                key:'Ecommpay MC'
            },
            {
                type: 'Bank Cards',
                minimumDeposit: 10,
                methodID: 5,
                id: 1,
                name: 'Visa Credit Card',
                image: 'visa.svg',
                region: 'World Wide',
                currencies: 'EUR, USD, CHF, GBP',
                processingTime: 'Instant',
                action: '',
                key:'Ecommpay Visa'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 17,
                id: 2,
                name: 'Virtual Pay',
                image: 'dep6.png',
                region: 'East Africa',
                currencies: 'TAS, KES, MTN',
                processingTime: '2-3 business days',
                action: '',
                key:'Virtual Pay'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 2,
                id: 3,
                name: 'Skrill',
                image: 'dep7.png',
                region: 'World Wide',
                currencies: 'EUR, USD, JPY, CHF, GBP, AUD',
                processingTime: '2-3 business days',
                action: '',
                key:'Skrill'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 3,
                id: 4,
                name: 'Neteller',
                image: 'dep8.png',
                region: 'World Wide',
                currencies: 'MY, TH, ID, PH, VN',
                processingTime: 'Instant',
                action: '',
                key:'Neteller'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 5,
                id: 16,
                name: 'Google Pay',
                image: 'google-pay.png',
                region: 'World Wide',
                currencies: 'MY, TH, ID, PH, VN',
                processingTime: 'Instant',
                action: '',
                key:'Google Pay'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 5,
                name: 'Capital Wallet',
                image: 'btc.png',
                region: 'World Wide',
                currencies: 'BTC',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 6,
                name: 'Capital Wallet',
                image: 'eth.png',
                region: 'World Wide',
                currencies: 'ETH',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 7,
                name: 'Capital Wallet',
                image: 'usdt.png',
                region: 'World Wide',
                currencies: 'USDT',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            {
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id: 8,
                name: 'Capital Wallet',
                image: 'usdc.png',
                region: 'World Wide',
                currencies: 'USDC',
                processingTime: '30 mins',
                action: '',
                key:'Cryptos'
            },
            /*{
                type: 'Cryptos',
                minimumDeposit: 10,
                methodID: 18,
                id : 9,
                name: 'Bitcoin',
                image: 'bitcoin-ico.png',
                region: 'World Wide',
                currencies: 'BTC',
                processingTime: '30 mins',
                action: '',
                key:''
            },*/
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 9,
                name: 'Help 2 Pay',
                image: 'dep4.png',
                region: 'South East Asia',
                currencies: 'MY, TH, ID, PH, VN',
                processingTime: 'Instant',
                action: '',
                key:'Help2Pay'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 10,
                name: 'Pay Retailers',
                image: 'dep5.png',
                region: 'Brazil, Mexico, Chile',
                currencies: 'BRL, MXN, CLP',
                processingTime: 'Instant',
                action: '',
                key:'PayRetailers'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 11,
                name: 'ASTROPAY',
                image: 'astropay.svg',
                region: 'World Wide',
                currencies: 'EUR, USD, GBP',
                processingTime: 'Instant',
                action: '',
                key:'AstroPay'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 12,
                name: 'FAIRPAY CASH',
                image: 'fairpay_cash.svg',
                region: 'LATAM',
                currencies: 'USD, BRL, CLP, CRC, MXN, PEN',
                processingTime: 'Instant',
                action: '',
                key:'FairPay Cash'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 13,
                name: 'FAIRPAY ONLINE',
                image: 'fairpay_online.svg',
                region: 'LATAM',
                currencies: 'USD, BRL, CLP, CRC, MXN, PEN',
                processingTime: 'Instant',
                action: '',
                key:'FairPay Online'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 14,
                name: 'Eurobank',
                image: 'dep2.png',
                region: 'World Wide',
                currencies: 'USD',
                processingTime: '2-3 business days',
                action: '',
                key:'Eurobank'
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 15,
                name: 'Dixipay',
                image: 'dep3.png',
                region: 'Europe',
                currencies: 'EUR (Sepa Only)',
                processingTime: '2-3 business days',
                action: '',
                key:''
            },
            {
                type: 'Bank Wire',
                minimumDeposit: 10,
                methodID: 17,
                id: 17,
                name: 'Kora Pay',
                image: 'korapay.svg',
                region: 'Africa',
                currencies: 'KSH, NGN',
                processingTime: 'Instant',
                action: '',
                key:'KoraPay'
            },
            {
                type: 'E-Wallet',
                minimumDeposit: 10,
                methodID: 5,
                id: 20,
                name: 'Apple Pay',
                image: 'apple-pay.png',
                region: 'World Wide',
                currencies: '',
                processingTime: 'Instant',
                action: '',
                key:'Apple Pay'
            },
            
        ]
    },
    timezones: [
        { value: "-12:00", label: '(GMT -12:00) Eniwetok, Kwajalein' },
        { value: "-11:00", label: '(GMT -11:00) Midway Island, Samoa' },
        { value: "-10:00", label: '(GMT -10:00) Hawaii' },
        { value: "-09:50", label: '(GMT -9:30) Taiohae' },
        { value: "-09:00", label: '(GMT -9:00) Alaska' },
        { value: "-08:00", label: '(GMT -8:00) Pacific Time (US &amp; Canada)' },
        { value: "-07:00", label: '(GMT -7:00) Mountain Time (US &amp; Canada)' },
        { value: "-06:00", label: '(GMT -6:00) Central Time (US &amp; Canada), Mexico City' },
        { value: "-05:00", label: '(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima' },
        { value: "-04:50", label: '(GMT -4:30) Caracas' },
        { value: "-04:00", label: '(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz' },
        { value: "-03:50", label: '(GMT -3:30) Newfoundland' },
        { value: "-03:00", label: '(GMT -3:00) Brazil, Buenos Aires, Georgetown' },
        { value: "-02:00", label: '(GMT -2:00) Mid-Atlantic' },
        { value: "-01:00", label: '(GMT -1:00) Azores, Cape Verde Islands' },
        { value: "+00:00", label: '(GMT) Western Europe Time, London, Lisbon, Casablanca' },
        { value: "+01:00", label: '(GMT +1:00) Brussels, Copenhagen, Madrid, Paris' },
        { value: "+02:00", label: '(GMT +2:00) Kaliningrad, South Africa' },
        { value: "+03:00", label: '(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg' },
        { value: "+03:50", label: '(GMT +3:30) Tehran' },
        { value: "+04:00", label: '(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi' },
        { value: "+04:50", label: '(GMT +4:30) Kabul' },
        { value: "+05:00", label: '(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent' },
        { value: "+05:50", label: '(GMT +5:30) Bombay, Calcutta, Madras, New Delhi' },
        { value: "+05:75", label: '(GMT +5:45) Kathmandu, Pokhara' },
        { value: "+06:00", label: '(GMT +6:00) Almaty, Dhaka, Colombo' },
        { value: "+06:50", label: '(GMT +6:30) Yangon, Mandalay' },
        { value: "+07:00", label: '(GMT +7:00) Bangkok, Hanoi, Jakarta' },
        { value: "+08:00", label: '(GMT +8:00) Beijing, Perth, Singapore, Hong Kong' },
        { value: "+08:75", label: '(GMT +8:45) Eucla' },
        { value: "+09:00", label: '(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk' },
        { value: "+09:50", label: '(GMT +9:30) Adelaide, Darwin' },
        { value: "+10:00", label: '(GMT +10:00) Eastern Australia, Guam, Vladivostok' },
        { value: "+10:50", label: '(GMT +10:30) Lord Howe Island' },
        { value: "+11:00", label: '(GMT +11:00) Magadan, Solomon Islands, New Caledonia' },
        { value: "+11:50", label: '(GMT +11:30) Norfolk Island' },
        { value: "+12:00", label: '(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka' },
        { value: "+12:75", label: '(GMT +12:45) Chatham Islands' },
        { value: "+13:00", label: '(GMT +13:00) Apia, Nukualofa' },
        { value: "+14:00", label: '(GMT +14:00) Line Islands, Tokelau' },

    ],
    european_countries_list: {
        "AT": 'Austria',
        "BE": 'Belgium',
        "BG": 'Bulgaria',
        "CY": 'Cyprus',
        "CZ": 'Czechia',
        "DE": 'Germany',
        "DK": 'Denmark',
        "EE": 'Estonia',
        "ES": 'Spain',
        "FI": 'Finland',
        "FR": 'France',
        "GR": 'Greece',
        "HR": 'Croatia',
        "HU": 'Hungary',
        "IE": 'Ireland',
        "IT": 'Italy',
        "LT": 'Lithuania',
        "LU": 'Luxembourg',
        "LV": 'Latvia',
        "MT": 'Malta',
        "NL": 'Netherlands',
        "PO": 'Poland',
        "PT": 'Portugal',
        "RO": 'Romania',
        "SE": 'Sweden',
        "SI": 'Slovenia',
        "SK": 'Slovakia',
        "GB": 'United Kingdom'
    },
    fileNames: [
        { name: 'Passport', value: 'Passport', type: 'Proof_of_Identity' },
        { name: 'Drivers_License_BACK', value: 'Drivers License Back', type: 'Proof_of_Identity' },
        { name: 'Drivers_License_FRONT', value: 'Drivers License Front', type: 'Proof_of_Identity' },
        { name: 'Government_Issued_Photo_ID_BACK', value: 'Government Issued Photo ID Back', type: 'Proof_of_Identity' },
        { name: 'Government_Issued_Photo_ID_FRONT', value: 'Government Issued Photo ID Front', type: 'Proof_of_Identity' },
        { name: 'Bank_Credit_Card_Statement', value: 'Bank Statement/Credit Card Statement', type: 'Proof_of_Residence' },
        { name: 'Utility_Bill', value: 'Utility Bill', type: 'Proof_of_Residence' },
        { name: 'Payroll_Statement', value: 'Payroll Statement', type: 'Proof_of_Residence' },
        { name: 'Tax_Document', value: 'Tax Document', type: 'Proof_of_Residence' },
        { name: 'Photo_Verification', value: 'Liveness/Selfie', type: 'Photo_Verification' }
    ],
    paymentOptionsForCountry: {
        "AD": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "AE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AF": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AL": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "AO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AU": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "AZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "BB": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BD": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BE": {
            "Banking": false,
            "Cryptos": false,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BF": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "BG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BH": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BI": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BJ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "BM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "BN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "BO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "BR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": true,
            "FairPay Online": true,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "BW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "BZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "CA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CD": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CH": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CI": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "CL": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": true,
            "FairPay Online": true,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "CM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": true,
            "FairPay Online": true,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "CU": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CV": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "CY": {
            "Banking": false,
            "Cryptos": false,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "CZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "DE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "DJ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "DK": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "DM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "DO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "DZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "EC": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "EE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "EG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ER": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ES": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ET": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "FI": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "FJ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "FM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "FR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GB": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GD": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "GE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "GH": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": true,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GQ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "GW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "GY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "HK": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "HN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "HR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "HT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "HU": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ID": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": true,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "IE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "IL": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "IN": {
            "Banking": false,
            "Cryptos": false,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": true,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "IQ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "IR": {
            "Banking": false,
            "Cryptos": false,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "IS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "IT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "JM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "JO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "JP": {
            "Banking": false,
            "Cryptos": false,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "KE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": true,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": true
        },
        "KG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "KH": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": true,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "KI": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "KM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "KN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "KP": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "KR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "KW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "KY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "KZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "LA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LB": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LC": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "LI": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LK": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "LR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LU": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LV": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "LY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MC": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MD": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ME": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "MG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MH": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "ML": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "MR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MU": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MV": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "MW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MX": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": true,
            "FairPay Online": true,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "MY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": true,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "MK": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "NA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "NE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "NG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": true,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": true,
        },
        "NI": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "NL": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "NO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "NP": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "NR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "NZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "OM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "PA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "PE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": true,
            "FairPay Online": true,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "PG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "PH": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": true,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "PK": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "PL": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "PS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "PT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "PW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "PY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "QA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "RO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "RS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "RU": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "RW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SB": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "SC": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "SD": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SI": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SK": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SL": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "SN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "SS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ST": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "SV": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": true,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "SY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "SZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TD": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TH": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": true,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "TJ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "TL": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "TN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TO": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "TR": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TT": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TV": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "TZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": true,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "TW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "UA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "UG": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": true,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "US": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": false,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "UY": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "UZ": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "VA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "VC": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "VE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "VN": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": true,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "VU": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "WS": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "XK": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": true,
            "Ecommpay Visa": true,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": true,
            "Google Pay": true,
            "Swiffy": false,
            "KoraPay": false
        },
        "YE": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": false,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ZA": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": true,
            "KoraPay": false
        },
        "ZM": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": true,
            "PayRetailers": false,
            "Skrill": true,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        },
        "ZW": {
            "Banking": false,
            "Cryptos": true,
            "Ecommpay MC": false,
            "Ecommpay Visa": false,
            "Neteller": false,
            "PayRetailers": false,
            "Skrill": false,
            "Help2Pay": false,
            "Virtual Pay": false,
            "AstroPay": true,
            "FairPay Cash": false,
            "FairPay Online": false,
            "Eurobank": true,
            "Apple Pay": false,
            "Google Pay": false,
            "Swiffy": false,
            "KoraPay": false
        }
    },

}